export const IndexSetActiveMenu = 'IndexSetActiveMenu';
export const IndexSetAddedMembers = 'IndexSetAddedMembers';
export const IndexSetRemovedMember = 'IndexSetRemovedMember';

export const SESSION_SET_SESSION = 'SESSION_SET_SESSION';
export const CHAT_SET_USER_CHAT_FRIENDS_SETTINGS =
    'CHAT_SET_USER_CHAT_FRIENDS_SETTINGS';
export const CHAT_SET_FRIENDS = 'CHAT_SET_FRIENDS';
export const CHAT_SELECTED_USER = 'CHAT_SELECTED_USER';
export const CHAT_SET_OPEN = 'CHAT_SET_OPEN';
export const CHAT_LOAD_PREVIOUS_USER_MESSAGES =
    'CHAT_LOAD_PREVIOUS_USER_MESSAGES';
export const CHAT_SET_FRIEND_OF_FRIENDS = 'CHAT_SET_FRIEND_OF_FRIENDS';
export const CHAT_SET_FRIEND_IS_ONLINE = 'CHAT_SET_FRIEND_IS_ONLINE';
export const CHAT_SET_FRIEND_STATE = 'CHAT_SET_FRIEND_STATE';
export const CHAT_SET_FRIEND_UNREAD_COUNT = 'CHAT_SET_FRIEND_UNREAD_COUNT';
export const CHAT_SET_FRIEND_MESSAGES = 'CHAT_SET_FRIEND_MESSAGES';
export const CHAT_SET_MESSAGE_FROM_FRIEND = 'CHAT_SET_MESSAGE_FROM_FRIEND';
export const CHAT_SET_FRIEND_MESSAGE_READ_STATE = 'CHAT_SET_FRIEND_MESSAGE_READ_STATE';
export const CHAT_SET_FRIEND_MESSAGE_RECEIVER_READ_STATE = 'CHAT_SET_FRIEND_MESSAGE_RECEIVER_READ_STATE';
